import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem } from '@dbk/ui-list';
import { Radio } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';
import languageData from '../../data/language-list.json';
import Button from '@dbk/ui-buttons';
import BlurModal from '../../components/common/blur-modal';
import ScrollableLayout from '../../components/common/scrollable-layout';
import Spinner from '@dbk/ui-spinner';
import Text,{H1} from '@dbk/ui-text';

class ProfileChangeLanguage extends Component {
  state = {
    showModal: false,
    selectLangObj: [],
  };

  componentDidUpdate(){
    if(document.querySelector('.ModalHeader span')){    // for language selection popup focus
      document.querySelector('.ModalHeader span').focus();
    }
  }

  handlePress = (languageObj, destLanguage) => {
    if (languageObj.language != destLanguage) {
      this.setState({ showModal: true, selectLangObj: languageObj });
    }
  };
  renderConfirmModal() {
    const { messages } = this.props.i18n;
    const confirmText = messages['app.profile.changeLanguage.confirmText'];
    const cancelText = messages['app.profile.changeLanguage.cancelText'];
    return (
      <div className="padding-left-10 padding-right-15">
        <div className="row">
          <div className="small-12">
            <div>
              <Text tabIndex={0}>{messages['app.profile.changeLanguage.confirmMsg']}</Text>
              <div className="row">
                <div className="column pad-top-20 small-push-1">
                  <div className="logout-confirm-btns margin-top-10">
                    <div id="btn_confirm_langugage_selection" className="column small-3 pad-bottom-0 center">
                      <Button testID="btn_confirm_langugage_selection_id"
                        size="large"
                        fullWidth
                        onClick={this.pressedConfirm}
                      >
                        {confirmText}
                      </Button>
                    </div>
                    <div className="column center small-3">
                      <Button
                        testID="btn_language_cancel_profileLanguageOptions_test"
                        size="large"
                        fullWidth
                        tertiary
                        onClick={this.pressedCancel}
                      >
                        {cancelText}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  pressedConfirm = () => {
    this.setState({ showModal: false });
    const languageObj = this.state.selectLangObj;
    const {
      languages,
      changePage,
      i18n: { messages },
    } = this.props;
    languages.saveLanguage({ languageObj });
    // changePage({ pathname: '/profile' });
    // alert(messages['app.profile.language.changeLanguageMsg']);
  };

  pressedCancel = () => this.setState({ showModal: false });

  renderListItems = (item, selectedLanguage, key) => {
    const { auth: { settingsDisabled } } = this.props;
    return (
      <ListItem
        role="none"
        testID="list_languageSelection_profileLanguageOption_test"
        onClick={() => !settingsDisabled ? this.handlePress(item, selectedLanguage) : null }
        className="consolidation__list-item" tabIndex={-1} >
        <span id={`language_selection_radio_${key}`} className='displayContent'>
          <Radio
            title={item.language}
            className="profile__radio-button"
            checked={selectedLanguage === item.language}
            disabled={settingsDisabled} />
          <Text size="large" tabIndex={0} className="currency currency__list-item">{item.language}</Text>
        </span>
      </ListItem>
    )
  };

  render() {
    const languageList = languageData.languageList;
    const {
      i18n: { messages },
      languages: { destLanguage, loadingLanguage },
    } = this.props;
    const selectedLanguage = destLanguage || 'English';

    return (
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
           {loadingLanguage && <div className="columns small-12 center-content pad-top-15 profile-language-spinner"><Spinner /></div>}
            <div className="columns small-12 large-12  profile-container">
              <div className="profile-container__title">
                <H1 className="margin-top-1" tabIndex={0}>{messages['app.common.pageTitle.changeLanguage']}</H1>
              </div>
              <div>
              <Text tabIndex={0} className="profile__content-info">
                  {messages['app.profile.languageHead']}
                </Text>
              </div>
              <div className="profile__content">
                <div>
                  <div className="settings-list-item consolidation__items-wrapper">
                    <List className="profile__list" fullWidth>
                      {languageList.map((e,key) => this.renderListItems(e, selectedLanguage, key))}
                    </List>
                  </div>
                </div>
              </div>
            </div>
            <BlurModal
              visible={this.state.showModal}
              doneVisible={false}
              title={messages['app.common.pageTitle.changeLanguage']}
              onDone={this.pressedCancel}
            >
              {this.renderConfirmModal()}
            </BlurModal>
          </div>
        }
      />
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      destinationCurrency: true,
      settingsDisabled: true
    },
    languages: {
      saveLanguage: { $call: 'saveLanguage' },
      destLanguage: true,
      destLanguageCode: true,
      loadingLanguage: true
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
  },
})(ProfileChangeLanguage);
